import { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { MARKET_BUZZ_PAGE_SIZE } from '../../../utils/constants';

import {
  requestPopulateMarketBuzzFilter,
  requestViewPosts,
  requestViewReactions,
} from '../../../api/market-buzz/market-buzz.actions';
import { setPage, setPost, setProduct } from '../../../slices/market-buzz/market-buzz.slice';

import MarketBuzz from '../../../components/screens/market/market-buzz/MarketBuzz';

const MarketBuzzContainer = () => {
  const [isLastPostLoaded, setIsLastPostLoaded] = useState(false);

  const { filters, organisations, persons, posts, reactions, page } = useSelector(({ marketBuzz }) => marketBuzz);
  const { profile, adminRole } = useSelector(({ party }) => party);
  const currencyCode = useSelector(({ currency }) => currency.currencyCode);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const viewPosts = useCallback(
    (filters, resetPage) => {
      if (resetPage) {
        dispatch(setPage(0));
      }
      dispatch(
        requestViewPosts({
          filters,
          onSuccess: (pageLength) => {
            if (pageLength < MARKET_BUZZ_PAGE_SIZE) {
              setIsLastPostLoaded(true);
            }
          },
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    dispatch(requestPopulateMarketBuzzFilter());
    dispatch(requestViewReactions());
  }, [dispatch]);

  useEffect(() => {
    if (page === 0) {
      viewPosts({});
    }
  }, [dispatch, viewPosts, page]);

  useEffect(() => {
    viewPosts(filters, true);
  }, [currencyCode, viewPosts, filters]);

  const navigateToCreatePost = () => {
    dispatch(setPost(undefined));
    dispatch(setProduct(undefined));
    navigate('create');
  };

  return (
    <MarketBuzz
      filters={filters}
      organisations={organisations}
      persons={persons}
      profile={profile}
      posts={posts}
      reactions={reactions}
      adminRole={adminRole}
      isLastPostLoaded={isLastPostLoaded}
      setIsLastPostLoaded={setIsLastPostLoaded}
      viewPosts={viewPosts}
      navigateToCreatePost={navigateToCreatePost}
    />
  );
};

export default MarketBuzzContainer;
